module.exports = __webpack_public_path__ + "img/2012-08-18 10.53.08.ee09c1a7.jpg";